import React, { useState, useEffect } from "react";
import axios from "axios";
import { GrView } from "react-icons/gr";
import { FaEdit } from "react-icons/fa";
import { MdDelete, MdOutlineAdd } from "react-icons/md";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

function Employee() {
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [selectedStage, setSelectedStage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmployeeData = async () => {
      const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `https://api-in21.leadsquared.com/v2/UserManagement.svc/Users.Get?accessKey=u$r1d64e7e490a71e5105cf6a1a3efcd1fe&secretKey=${process.env.REACT_APP_SECRET_KEY}`,
        headers: {}
      };

      try {
        const response = await axios.request(config);
        console.log(response.data); // Log for dev purpose
        setEmployeeDetails(response.data); // Adjust if structure is different
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    fetchEmployeeData();
  }, []);

  const handleViewClick = (employee) => {
    navigate(`/empdetails/${employee}`);
  };

  const allData = employeeDetails.map((data, index) => ({
    employeeName: data.FirstName || "N/A",
    employeeRole: data.Role || "N/A",
    EmailAddress: data.EmailAddress || "N/A",
    MemberOfGroups: data?.MemberOfGroups,
    edit: <FaEdit />,
    delete: <MdDelete style={{ fontSize: "20px", color: 'red', cursor: "pointer" }} />,
    stage: index,
  }));

  const columns = [
    { name: "S.No", selector: (row, index) => index + 1, sortable: true },
    { name: "Name", selector: (row) => row.employeeName, sortable: true },
    { name: "Role", selector: (row) => row.employeeRole, sortable: true },
    { name: "Email", selector: (row) => row.EmailAddress, sortable: true },
    { name: "MemberOfGroups", selector: (row) => row.MemberOfGroups, sortable:true },
    { name: "Edit", selector: (row) => row.edit },
    { name: "Delete", selector: (row) => row.delete },
  ];

  return (
    <div className="department">
      <div className="row">
        <div className="col-lg-10 mt-3 mb-3">
          <h3>Employee Details</h3>
        </div>
        <div className="col-lg-2 mt-3">
          <button style={{ backgroundColor: "green", color: "white", borderRadius: "10px" }}>
            Add <MdOutlineAdd style={{ fontSize: "15px" }} />
          </button>
        </div>
        <div className="col-lg-12">
          <DataTable
            columns={columns}
            data={allData.filter((row) => selectedStage === "" || row.stage.toString() === selectedStage)}
            pagination
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 15, 20]}
            responsive
            highlightOnHover
            striped
            noDataComponent={<div>No data available</div>}
          />
        </div>
      </div>
    </div>
  );
}

export default Employee;
